import { Collection } from 'modules/core/lib/mobx-rest'

import { CompanyLink, ICompanyLink } from 'modules/dashboard/store/models/CompanyLink'

interface BulkUpdateParams {
  links: ICompanyLink[]
  linkIdsToBeDeleted: string[]
}
class CompanyLinks extends Collection<CompanyLink> {
  get cacheKey(): string {
    return 'companyLinks'
  }

  model() {
    return CompanyLink
  }

  bulkUpdate({ links, linkIdsToBeDeleted }: BulkUpdateParams) {
    return this.rpc('bulk_update', {
      links,
      link_ids_to_be_deleted: linkIdsToBeDeleted,
    })
  }
}

const singleton: CompanyLinks = new CompanyLinks()

export default singleton
